import { WorkoutFilters } from '../models/workout-filters';
import { partitionWorkoutFilters } from './partition-workout-filters';

export function workoutFiltersToMongoQuery(workoutFilters: WorkoutFilters): {
  $in?: string[];
  $nin?: string[];
  $all?: string[];
} {
  if (!workoutFilters || !workoutFilters.length) {
    return {};
  }

  const { allowed, excluded, required } =
    partitionWorkoutFilters(workoutFilters);

  return {
    ...(allowed.length && { $in: allowed }),
    ...(excluded.length && { $nin: excluded }),
    ...(required.length && { $all: required }),
  };
}
